import { render, staticRenderFns } from "./MainSite.vue?vue&type=template&id=37a45a07&scoped=true&"
import script from "./MainSite.vue?vue&type=script&lang=js&"
export * from "./MainSite.vue?vue&type=script&lang=js&"
import style0 from "./MainSite.vue?vue&type=style&index=0&id=37a45a07&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a45a07",
  null
  
)

export default component.exports